import React, {Component} from "react";
import PropTypes from 'prop-types';
import {Row, Col, Progress, Card, Alert, CardHeader, CardTitle, FormGroup, Label, Form, Input, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, Button, ButtonDropdown, Table, Badge,  Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem, FormText, InputGroup,  Nav, NavItem, NavLink, TabContent, TabPane} from 'reactstrap';
import {Bar, Line} from "react-chartjs-2";
import classNames from 'classnames';
import {mapToCssModules} from 'reactstrap/lib/utils';
import classnames from "classnames";
import { RIEToggle, RIEInput, RIETextArea, RIENumber, RIETags, RIESelect } from 'riek'
import _ from 'lodash'
import Select from 'react-select';
import 'react-select/dist/react-select.min.css';
import Popover from 'react-awesome-popover';
import "react-awesome-popover/dest/react-awesome-popover.css";
import TagBindingStructure from '../Support/TagBindingStructure';
const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';



const propTypes = {
    header: PropTypes.string,
    mainText: PropTypes.string,
    icon: PropTypes.string,
    color: PropTypes.string,
    variant: PropTypes.string,
    footer: PropTypes.bool,
    link: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    cssModule: PropTypes.object,
    systemVoltage: PropTypes.number,
    developer: PropTypes.bool,
    valuechangeinput: PropTypes.func,
};
const defaultProps = {
    header: 'Undefined',
    mainText: 'Undefined',
    icon: "fa fa-cogs",
    color: 'gray-100',
    variant: "0",
    link: "#"
};

class ComponentGenerator extends Component {

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            activeTab: '1',
            selectTagModal: false
        };
        this.valueChanged = this.valueChanged.bind(this);
        this.toggleSelectTagModal = this.toggleSelectTagModal.bind(this);
        this.saveChangesSelectTag = this.saveChangesSelectTag.bind(this);

    }


    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }
    valueChanged(e) {
        let keyName = Object.keys(e)[0];
        this.props.valuechangeinput(keyName,e[keyName]);
    }
    toggleSelectTagModal() {
        this.setState({
            selectTagModal: !this.state.selectTagModal
        });
    }
    saveChangesSelectTag(value) {
        this.setState({
            addAlarmTag: value.value
        });
    }

    convertBits(word = 0, bit = 0){
        let arrayReturned = [];
        for (let i = 0; i < 15; i++)
            arrayReturned[i] = (word >> i) & 1;
        return arrayReturned[bit] === 1;
    }
    round(value, decimals) {
        return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
    }
    checkTagBit(schema, returnText = true) {
        //console.log('test -> ' + this.convertBits(this.props.iotData[schema.tag.id],schema.tagBit.id));
        //console.log('schema.tag.id: ' + schema.tag.id);
        //console.log('here:' + this.props.iotData[schema.tag.id]);
        return schema.tagBit.text === "noBit" ? this.round(parseFloat(this.props.iotData[schema.tag.id] || 0 ) * parseFloat(schema.tagScale || 1) + parseFloat(schema.tagOffset || 0),parseInt(schema.tagDecimals)): returnText ? this.convertBits(this.props.iotData[schema.tag.id],schema.tagBit.id) ? "On" : "Off" : this.convertBits(this.props.iotData[schema.tag.id],schema.tagBit.id);
    }

    checkTagFill(schema) {
        //console.log('test -> ' + this.convertBits(this.props.iotData[schema.tag.id],schema.tagBit.id));
        let percent = (parseInt(this.props.iotData[schema.tag.id] || 0 ) - parseInt(schema.engMin)) / (parseInt(schema.engMax) - parseInt(schema.engMin));
        return Math.ceil(percent * (parseInt(schema.tagMax) - parseInt(schema.tagMin)) + parseInt(schema.tagMin));
    }

    render() {
        const {className, cssModule, header, mainText, icon, color, footer, link, children, variant, ...attributes} = this.props;

        const padding = (variant === '0' ? {card: "p-3", icon: "p-3", lead: "mt-2"} : ( variant === "1" ? {
            card: "p-0", icon: "p-4", lead: "pt-3" } : {card: "p-0", icon: "p-4 px-5", lead: "pt-3"}));

        const card = {style: "card-body clearfix", color: color, icon: icon, classes: ""};
        card.classes = mapToCssModules(classNames(className, card.style, padding.card), cssModule);

        const lead = {style: "h5 mb-0", color: color, classes: ""};
        lead.classes = classNames(lead.style, 'text-' + card.color, padding.lead);

        const blockIcon = function (icon) {
            const classes = classNames(icon, 'bg-' + card.color, padding.icon, "font-2xl mr-3 float-left");
            return (<i className={ classes }></i>);
        };

        let componentData = this.props.componentdata;

        return (
            <Card className={this.props.developer ? "mt-1" : ""}>
                <CardBody className={ card.classes }>
                    { blockIcon(card.icon) }
                    <div className={ lead.classes }>
                        <RIEInput
                            value={componentData.name}
                            change={this.valueChanged}
                            propName='name'
                            isDisabled={!this.props.developer}
                        />
                    </div>
                    <div className="text-muted text-uppercase font-weight-bold font-xs">
                        <RIEInput
                            value={componentData.desc}
                            change={this.valueChanged}
                            propName='desc'
                            isDisabled={!this.props.developer}
                        />
                    </div>
                    <hr />
                    {this.props.developer &&
                    ( <Row className="pb-3">
                        <Col sm="12">
                            <RIEToggle
                                className={`btn btn-block btn-sm ${componentData.breaker.visibility ? "btn-developer" : "btn-secondary"}`}
                                value={componentData.breaker.visibility}
                                change={this.valueChanged}
                                textTrue="Hide Aux"
                                textFalse="Show Aux"
                                propName='breaker.visibility'
                                isDisabled={false}
                            />
                        </Col>
                    </Row> )}
                    {componentData.breaker.visibility ?
                        <Row>
                            <Col xs="5" sm="5" lg="5">
                                <div className="text-muted text-uppercase font-weight-normal font-xs">
                                    <RIEInput
                                        value={componentData.breaker.name}
                                        change={this.valueChanged}
                                        propName='breaker.name'
                                        isDisabled={!this.props.developer}
                                    />
                                </div>
                            </Col>
                            <Col xs="5" sm="4" lg="5">
                                <div>{this.checkTagBit(componentData.breaker,false)?
                                    <Badge color={componentData.breaker.boolConfig.trueColor.id}>{componentData.breaker.boolConfig.trueMsg}</Badge> :
                                    <Badge color={componentData.breaker.boolConfig.falseColor.id}>{componentData.breaker.boolConfig.falseMsg}</Badge>}</div>
                            </Col>
                            {this.props.developer && (
                            <Col xs="1" sm="1" lg="1">
                                <TagBindingStructure
                                    valueTag={componentData.breaker.tag}
                                    optionsTag={this.props.iodb}
                                    propNameTag="breaker.tag"
                                    valueBit={componentData.breaker.tagBit}
                                    optionsBit={this.props.tagBits}
                                    propNameBit="breaker.tagBit"
                                    change={this.valueChanged}
                                    componentIsBeingEdited={(status) => this.props.componentIsBeingEdited(status)}
                                    isBool={true}
                                    valueBoolConfig={componentData.breaker.boolConfig}
                                    propNameBoolConfig="breaker.boolConfig"
                                />
                            </Col> )}
                        </Row>
                        : ""
                    }
                    {componentData.breaker.visibility ? <hr /> : ""}
                    {this.props.developer &&
                    ( <Row className="pb-3">
                        <Col sm="12">
                            <RIEToggle
                                className={`btn btn-block btn-sm ${componentData.tank.visibility ? "btn-developer" : "btn-secondary"}`}
                                value={componentData.tank.visibility}
                                change={this.valueChanged}
                                textTrue="Hide Tank"
                                textFalse="Show Tank"
                                propName='tank.visibility'
                                isDisabled={false}
                            />
                        </Col>
                    </Row> )}
                    {componentData.tank.visibility ?
                        <Row>
                            <Col xs="5" sm="5" lg="5">
                                <div className="text-muted text-uppercase font-weight-normal font-xs">Fuel Tank Level</div>
                            </Col>
                            {this.props.developer &&
                            <Col xs="2" sm="2" lg="2">
                                <TagBindingStructure
                                    valueTag={componentData.tank.tag}
                                    optionsTag={this.props.iodb}
                                    propNameTag="tank.tag"
                                    valueBit={componentData.breaker.tagBit}
                                    optionsBit={this.props.tagBits}
                                    propNameBit="tank.tagBit"
                                    change={this.valueChanged}
                                    fillBar
                                    componentIsBeingEdited={(status) => this.props.componentIsBeingEdited(status)}
                                    valueTagMin={componentData.tank.tagMin}
                                    valueNameTagMin={`tank.tagMin`}
                                    valueTagMax={componentData.tank.tagMax}
                                    valueNameTagMax={`tank.tagMax`}
                                    valueEngMin={componentData.tank.engMin}
                                    valueNameEngMin={`tank.engMin`}
                                    valueEngMax={componentData.tank.engMax}
                                    valueNameEngMax={`tank.engMax`}
                                />
                            </Col> }
                        </Row>
                        : ""
                    }

                    {componentData.tank.visibility ?
                        <Row>
                            <Col xs="12" sm="12" lg="12">
                                <Progress striped color="primary" value={this.checkTagFill(componentData.tank)} className="mt-2">{this.checkTagFill(componentData.tank)}%</Progress>
                            </Col>
                        </Row>
                        : ""
                    }
                    {componentData.tank.visibility ? <hr /> : ""}
                    {this.props.developer && (
                    <Row className="pb-3">
                        <Col sm="6">
                            <RIEToggle
                                className={`btn btn-block btn-sm ${componentData.metering.visibility ? "btn-developer" : "btn-secondary"}`}
                                value={componentData.metering.visibility}
                                change={this.valueChanged}
                                textTrue="Hide Metering"
                                textFalse="Show Metering"
                                propName='metering.visibility'
                                isDisabled={false}
                            />
                        </Col>
                        <Col sm="6">
                            <RIEToggle
                                className={`btn btn-block btn-sm ${componentData.engine.visibility ? "btn-developer" : "btn-secondary"}`}
                                value={componentData.engine.visibility}
                                change={this.valueChanged}
                                textTrue="Hide Engine"
                                textFalse="Show Engine"
                                propName='engine.visibility'
                                isDisabled={false}
                            />
                        </Col>
                    </Row>)}

                    {(this.props.developer ? componentData.metering.visibility || componentData.engine.visibility : componentData.metering.visibility && componentData.engine.visibility) ?
                    <Nav tabs>
                        {componentData.metering.visibility ?
                        <NavItem>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === '1' })}
                                onClick={() => { this.toggle('1'); }}
                            >
                                Metering
                            </NavLink>
                        </NavItem>
                            :
                            ""}
                        {componentData.engine.visibility ?
                            <NavItem>
                                <NavLink
                                    className={classnames({active: componentData.metering.visibility ? this.state.activeTab === '2' : this.state.activeTab === '1'})}
                                    onClick={() => {this.toggle(componentData.metering.visibility ? '2' : '1');}}
                                >
                                    Engine
                                </NavLink>
                            </NavItem> : ""
                        }
                    </Nav> : "" }
                    {componentData.metering.visibility || componentData.engine.visibility ?
                    <TabContent activeTab={this.state.activeTab}>
                        {componentData.metering.visibility ?
                            <TabPane tabId="1">
                                {componentData.metering.data.map((row,index) => {
                                    return (
                                        <div key={index}>
                                            <Row>
                                                <Col xs="5" sm="5" lg="5">
                                                    <div className="text-muted text-uppercase font-weight-normal font-xs">
                                                        <RIEInput
                                                            value={row.name}
                                                            change={this.valueChanged}
                                                            propName={`metering.data.${index}.name`}
                                                            isDisabled={!this.props.developer}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col xs="5" sm="5" lg="5">
                                                    <div className="text-black-50 font-xs font-weight-bold">{this.checkTagBit(row)}</div>
                                                </Col>
                                                {this.props.developer && (
                                                <Col xs="1" sm="1" lg="1">
                                                    <TagBindingStructure
                                                        valueTag={row.tag}
                                                        optionsTag={this.props.iodb}
                                                        propNameTag={`metering.data.${index}.tag`}
                                                        valueBit={row.tagBit}
                                                        optionsBit={this.props.tagBits}
                                                        propNameBit={`metering.data.${index}.tagBit`}
                                                        valueScale={row.tagScale}
                                                        valueNameScale={`metering.data.${index}.tagScale`}
                                                        valueOffset={row.tagOffset}
                                                        valueNameOffset={`metering.data.${index}.tagOffset`}
                                                        valueDecimals={row.tagDecimals}
                                                        valueNameDecimals={`metering.data.${index}.tagDecimals`}
                                                        change={this.valueChanged}
                                                        onclick={() => console.log('test')}
                                                    />
                                                </Col>)}
                                            </Row>
                                            <hr/>
                                        </div>
                                        )
                                })}
                                {this.props.developer && (<Button color="light btn-block btn-sm" onClick={() => this.props.addNewDataToChild('metering.data')}><i className="fa fa-plus"> </i></Button>)}
                            </TabPane>
                            : ""
                        }
                        {componentData.engine.visibility ?
                            <TabPane tabId={componentData.metering.visibility ? "2" : "1"}>
                                {componentData.engine.data.map((row,index) => {
                                    return (
                                        <div key={index}>
                                            <Row>
                                                <Col xs="5" sm="5" lg="5">
                                                    <div className="text-muted text-uppercase font-weight-normal font-xs">
                                                        <RIEInput
                                                            value={row.name}
                                                            change={this.valueChanged}
                                                            propName={`engine.data.${index}.name`}
                                                            isDisabled={!this.props.developer}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col xs="5" sm="5" lg="5">
                                                    <div className="text-black-50 font-xs font-weight-bold">{this.checkTagBit(row)}</div>
                                                </Col>
                                                {this.props.developer && (
                                                    <Col xs="1" sm="1" lg="1">
                                                        <TagBindingStructure
                                                            valueTag={row.tag}
                                                            optionsTag={this.props.iodb}
                                                            propNameTag={`engine.data.${index}.tag`}
                                                            valueBit={row.tagBit}
                                                            optionsBit={this.props.tagBits}
                                                            propNameBit={`engine.data.${index}.tagBit`}
                                                            valueScale={row.tagScale}
                                                            valueNameScale={`engine.data.${index}.tagScale`}
                                                            valueOffset={row.tagOffset}
                                                            valueNameOffset={`engine.data.${index}.tagOffset`}
                                                            valueDecimals={row.tagDecimals}
                                                            valueNameDecimals={`engine.data.${index}.tagDecimals`}
                                                            change={this.valueChanged}
                                                        />
                                                    </Col>)}
                                            </Row>
                                            <hr/>
                                        </div>
                                    )
                                })}
                                {this.props.developer && (<Button color="light btn-block btn-sm" onClick={() => this.props.addNewDataToChild('engine.data')}><i className="fa fa-plus"> </i></Button>)}
                            </TabPane>
                            : ""
                        }
                    </TabContent> : "" }
                    <Modal isOpen={this.state.selectTagModal} toggle={this.toggleDeleteAlarmPoint} >

                        <ModalBody>
                            <Row>
                                <Col sm="10">
                                    <CardTitle className="mb-1">Select Tag</CardTitle>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <hr className="mb-4"/>
                                </Col>
                            </Row>
                            <Row className="pb-2">
                                <Col sm="12">
                                    <div className="text-center">
                                        <FormGroup row>
                                            <Col xs="12" md="12">
                                                <Select
                                                    name="form-field-name2"
                                                    value={componentData.breaker.tag}
                                                    options={this.props.iodb}
                                                    onChange={this.saveChangesSelectTag}
                                                />
                                                <FormText color="muted">Select the variable which will trigger the alarm.</FormText>
                                            </Col>
                                        </FormGroup>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <hr className="mb-4"/>
                                </Col>
                            </Row>
                            <Row className="pb-4">
                                <Col sm="6" className="small text-muted">
                                    <Button color="link" className="btn btn-block" onClick={() => {this.toggleSelectTagModal();}}>Cancel</Button>
                                </Col>
                                <Col sm="6" className="small text-muted">
                                    <Button color="danger" className="btn btn-block">Delete</Button>
                                </Col>
                            </Row>
                        </ModalBody>
                    </Modal>
                </CardBody>

            </Card>
        )
    }
}

ComponentGenerator.propTypes = propTypes;
ComponentGenerator.defaultProps = defaultProps;


export default ComponentGenerator;


// WEBPACK FOOTER //
// ./src/views/site/Developer/DeveloperOverviewRender/Components/ComponentGenerator.js